import { styled } from '@mui/material';
import { LegendType } from '../Chart.types';
import { ChartWrapperProps, LegendTypeDataSelector } from '../ChartWrapper';
import { RenderListLegend } from './ListLegend';
import { RenderTableLegend } from './TableLegend';

export const Legend = <Datum,>({
  data,
  legendType,
  total,
}: {
  data: Datum[];
  legendType: ChartWrapperProps['legendType'];
  total?: number;
}) => {
  const isTable = legendType === 'table-right';
  return <LegendWrapper>{isTable ? <RenderTableLegend data={data} total={total} /> : <RenderListLegend data={data} />}</LegendWrapper>;
};

const LegendWrapper = styled('div')({
  gridArea: 'legend',
  overflow: 'hidden',
  paddingTop: 8,
  paddingBottom: 10,
  width: '100%',
  height: '100%',

  [`${LegendTypeDataSelector[LegendType.tableRight]} &`]: {
    overflow: 'hidden',
    paddingTop: 12,
    paddingBottom: 12,
  },
});
